import ImageRecord from './ImageRecord';
import ApplicationRecord from './ApplicationRecord';

export default class Service
  extends ApplicationRecord({
    ID: 1,
    Title: '',
    Excerpt: '',
    Content: '',
    ButtonTitle: '',
    _embedded: {},
  }) {
  /**
   * Image
   * @return {List<ImageRecord>} [description]
   */
  images() {
    return this._getMany('Imgs', i => new ImageRecord(i));
  }
}



// WEBPACK FOOTER //
// ./src/models/Service.js